import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContextProvider";
import ProfileNav from "../../components/ProfileNav";

const Profile = () => {
  const location = useLocation();
  const inactiveClass = "text-gray-400";
  const activeClass = "text-text-orange";
  const { user } = useAuth();
  const permissions = user.permissionList;

  const profile = [
    // {
    //   name: "Profile Settings",
    //   path: "/settings/profile",
    // },
    // {
    //   name: "Update KYC",
    //   path: "/settings/profile/kyc-update",
    //   permission: "Upload Document",
    // },
    {
      name: "Password",
      path: "/settings/profile",
    },
    // {
    //   name: "Change PIN",
    //   path: "/settings/profile/change-pin",
    // },
    // {
    //   name: "Reset PIN",
    //   path: "/settings/profile/reset-pin",
    // },
  ];

  const hasUploadPermission = permissions.includes("Upload Document");

  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Profile
        </h1>
        <div>
          <ProfileNav />
        </div>
      </div>
      <div className="h-[924px] bg-white mt-8 rounded-[10px] p-[3rem]">
        <div className="bg-white w-[1100px] h-[828px] rounded-[10px]">
          <div className="border border-gray-200 rounded-t-[10px] p-[1rem]">
            <div className="flex items-center justify-between px-8">
              {profile?.map((p, index) => {
                if (
                  p.permission === "Upload Document" &&
                  !hasUploadPermission
                ) {
                  return null;
                }
                return (
                  <Link
                    key={index}
                    to={p.path}
                    className={
                      location.pathname === p.path ? activeClass : inactiveClass
                    }
                  >
                    {p?.name}
                  </Link>
                );
              })}
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 6.75L9 11.25L13.5 6.75"
                  stroke="#464255"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
